function createInput<T>(initialValue?: T) {
  return initialValue;
}

createInput.required = function <T>(initialValue: T) {
  return initialValue;
};

export { createInput as input };
